export default __webpack_public_path__ + "media/login-img-2-blur.6c8cb49c.svg";